/* Auto-generated from homelet-swagger.json */
/* eslint-disable import/prefer-default-export */
export const HOMELET_ENUM_OPTIONS = {
  EnumLettingType: [
    {
      value: 1,
      label: 'Let Only',
    },
    {
      value: 2,
      label: 'Fully Managed',
    },
    {
      value: 3,
      label: 'Rent Collect',
    },
    {
      value: 4,
      label: 'Guaranteed Rent',
    },
  ],
  PropertyTypes: [
    {
      value: 1,
      label: 'Detached',
    },
    {
      value: 2,
      label: 'Semi-Detached',
    },
    {
      value: 3,
      label: 'Flat',
    },
    {
      value: 4,
      label: 'Terraced',
    },
    {
      value: 5,
      label: 'Bungalow',
    },
    {
      value: 6,
      label: 'Other',
    },
  ],
  UkCountryEnum: [
    {
      value: 1,
      label: 'United Kingdom',
    },
  ],
  PropertyTenantType: [
    {
      value: 1,
      label: 'Lead Tenant',
    },
    {
      value: 2,
      label: 'Tenant',
    },
    {
      value: 3,
      label: 'Guarantor',
    },
    {
      value: 4,
      label: 'Tenant - Company',
    },
    {
      value: 5,
      label: 'Guarantor - Company',
    },
  ],
  Title: [
    {
      value: 1,
      label: 'Mr',
    },
    {
      value: 2,
      label: 'Mrs',
    },
    {
      value: 3,
      label: 'Miss',
    },
    {
      value: 4,
      label: 'Dr',
    },
    {
      value: 5,
      label: 'Ms',
    },
    {
      value: 7,
      label: 'Mx',
    },
    {
      value: 6,
      label: 'Other',
    },
  ],
  PersonalResidentStatus: [
    {
      value: 1,
      label: 'UK Resident',
    },
    {
      value: 2,
      label: 'Overseas',
    },
  ],
  AddressType: [
    {
      value: 1,
      label: 'Current Address',
    },
    {
      value: 2,
      label: 'Previous Address',
    },
    {
      value: 3,
      label: 'Last UK Addrees',
    },
  ],
  Months: [
    {
      value: 1,
      label: 'January',
    },
    {
      value: 2,
      label: 'February',
    },
    {
      value: 3,
      label: 'March',
    },
    {
      value: 4,
      label: 'April',
    },
    {
      value: 5,
      label: 'May',
    },
    {
      value: 6,
      label: 'June',
    },
    {
      value: 7,
      label: 'July',
    },
    {
      value: 8,
      label: 'August',
    },
    {
      value: 9,
      label: 'September',
    },
    {
      value: 10,
      label: 'October',
    },
    {
      value: 11,
      label: 'November',
    },
    {
      value: 12,
      label: 'December',
    },
  ],
  ResidentialStatus: [
    {
      value: 1,
      label: 'Homeowner',
    },
    {
      value: 2,
      label: 'Renting',
    },
    {
      value: 3,
      label: 'Living with friends/relatives',
    },
  ],
  IncomeType: [
    {
      value: 1,
      label: 'Employed',
    },
    {
      value: 2,
      label: 'Self-Employed',
    },
    {
      value: 3,
      label: 'Retired',
    },
    {
      value: 5,
      label: 'Student',
    },
    {
      value: 6,
      label: 'Unemployed',
    },
    {
      value: 7,
      label: 'Savings',
    },
    {
      value: 8,
      label: 'Investments',
    },
  ],
  IncomeTerm: [
    {
      value: 1,
      label: 'Primary Income',
    },
    {
      value: 2,
      label: 'Future Income',
    },
    {
      value: 3,
      label: 'Additional Income',
    },
    {
      value: 4,
      label: 'Secondary Income',
    },
  ],
  CountryEnum: [
    {
      value: 1,
      label: 'Cyprus',
    },
    {
      value: 2,
      label: 'United Kingdom',
    },
    {
      value: 3,
      label: 'India',
    },
    {
      value: 5,
      label: 'Andorra',
    },
    {
      value: 6,
      label: 'United Arab Emirates',
    },
    {
      value: 7,
      label: 'Afghanistan',
    },
    {
      value: 8,
      label: 'Antigua And Barbuda',
    },
    {
      value: 9,
      label: 'Anguilla',
    },
    {
      value: 10,
      label: 'Albania',
    },
    {
      value: 11,
      label: 'Armenia',
    },
    {
      value: 12,
      label: 'Caribbean Netherlands',
    },
    {
      value: 13,
      label: 'Angola',
    },
    {
      value: 15,
      label: 'Argentina',
    },
    {
      value: 16,
      label: 'American Samoa',
    },
    {
      value: 17,
      label: 'Austria',
    },
    {
      value: 18,
      label: 'Australia',
    },
    {
      value: 19,
      label: 'Aruba',
    },
    {
      value: 20,
      label: 'Azerbaijan',
    },
    {
      value: 21,
      label: 'Bosnia And Herzegowina',
    },
    {
      value: 22,
      label: 'Barbados',
    },
    {
      value: 23,
      label: 'Bangladesh',
    },
    {
      value: 24,
      label: 'Belgium',
    },
    {
      value: 25,
      label: 'Burkina Faso',
    },
    {
      value: 26,
      label: 'Bulgaria',
    },
    {
      value: 27,
      label: 'Bahrain',
    },
    {
      value: 28,
      label: 'Burundi',
    },
    {
      value: 29,
      label: 'Benin',
    },
    {
      value: 30,
      label: 'Bermuda',
    },
    {
      value: 31,
      label: 'Brunei Darussalam',
    },
    {
      value: 32,
      label: 'Bolivia',
    },
    {
      value: 33,
      label: 'Brazil',
    },
    {
      value: 34,
      label: 'Bahamas',
    },
    {
      value: 35,
      label: 'Bhutan',
    },
    {
      value: 37,
      label: 'Botswana',
    },
    {
      value: 38,
      label: 'Belarus',
    },
    {
      value: 39,
      label: 'Belize',
    },
    {
      value: 40,
      label: 'Canada',
    },
    {
      value: 41,
      label: 'Cocos (Keeling) Islands',
    },
    {
      value: 42,
      label: 'Central African Republic',
    },
    {
      value: 43,
      label: 'Congo',
    },
    {
      value: 44,
      label: 'Switzerland',
    },
    {
      value: 45,
      label: 'Côte d’Ivoire',
    },
    {
      value: 46,
      label: 'Cook Islands',
    },
    {
      value: 47,
      label: 'Chile',
    },
    {
      value: 48,
      label: 'Cameroon',
    },
    {
      value: 49,
      label: 'China',
    },
    {
      value: 50,
      label: 'Colombia',
    },
    {
      value: 51,
      label: 'Costa Rica',
    },
    {
      value: 52,
      label: 'Cuba',
    },
    {
      value: 53,
      label: 'Cape Verde',
    },
    {
      value: 54,
      label: 'Christmas Island',
    },
    {
      value: 55,
      label: 'Czech Republic',
    },
    {
      value: 56,
      label: 'Germany',
    },
    {
      value: 57,
      label: 'Djibouti',
    },
    {
      value: 58,
      label: 'Denmark',
    },
    {
      value: 59,
      label: 'Dominica',
    },
    {
      value: 60,
      label: 'Dominican Republic',
    },
    {
      value: 61,
      label: 'Algeria',
    },
    {
      value: 62,
      label: 'Ecuador',
    },
    {
      value: 63,
      label: 'Estonia',
    },
    {
      value: 64,
      label: 'Egypt',
    },
    {
      value: 65,
      label: 'Western Sahara',
    },
    {
      value: 66,
      label: 'Eritrea',
    },
    {
      value: 67,
      label: 'Spain',
    },
    {
      value: 68,
      label: 'Ethiopia',
    },
    {
      value: 69,
      label: 'Finland',
    },
    {
      value: 70,
      label: 'Fiji',
    },
    {
      value: 71,
      label: 'Falkland Islands (Malvinas)',
    },
    {
      value: 72,
      label: 'Micronesia, Federated States',
    },
    {
      value: 73,
      label: 'Faroe Islands',
    },
    {
      value: 74,
      label: 'France',
    },
    {
      value: 75,
      label: 'Gabon',
    },
    {
      value: 76,
      label: 'Grenada',
    },
    {
      value: 77,
      label: 'Georgia',
    },
    {
      value: 78,
      label: 'French Guiana',
    },
    {
      value: 79,
      label: 'Ghana',
    },
    {
      value: 80,
      label: 'Gibraltar',
    },
    {
      value: 81,
      label: 'Greenland',
    },
    {
      value: 82,
      label: 'Gambia',
    },
    {
      value: 83,
      label: 'Guinea',
    },
    {
      value: 84,
      label: 'Guadeloupe',
    },
    {
      value: 85,
      label: 'Equatorial Guinea',
    },
    {
      value: 86,
      label: 'Greece',
    },
    {
      value: 88,
      label: 'Guatemala',
    },
    {
      value: 89,
      label: 'Guam',
    },
    {
      value: 90,
      label: 'Guinea-Bissau',
    },
    {
      value: 91,
      label: 'Guyana',
    },
    {
      value: 92,
      label: 'Hong Kong',
    },
    {
      value: 94,
      label: 'Honduras',
    },
    {
      value: 95,
      label: 'Croatia (Local Name: Hrvatska)',
    },
    {
      value: 96,
      label: 'Haiti',
    },
    {
      value: 97,
      label: 'Hungary',
    },
    {
      value: 98,
      label: 'Indonesia',
    },
    {
      value: 99,
      label: 'Ireland (Republic of Ireland)',
    },
    {
      value: 100,
      label: 'Israel',
    },
    {
      value: 101,
      label: 'British Indian Ocean Territory',
    },
    {
      value: 102,
      label: 'Iraq',
    },
    {
      value: 103,
      label: 'Iran (Islamic Republic Of)',
    },
    {
      value: 104,
      label: 'Iceland',
    },
    {
      value: 105,
      label: 'Italy',
    },
    {
      value: 106,
      label: 'Jamaica',
    },
    {
      value: 107,
      label: 'Jordan',
    },
    {
      value: 108,
      label: 'Japan',
    },
    {
      value: 109,
      label: 'Kenya',
    },
    {
      value: 110,
      label: 'Kyrgyzstan',
    },
    {
      value: 111,
      label: 'Cambodia',
    },
    {
      value: 112,
      label: 'Kiribati',
    },
    {
      value: 113,
      label: 'Comoros',
    },
    {
      value: 114,
      label: 'Saint K Itts And Nevis',
    },
    {
      value: 115,
      label: "Korea, Dem People'S Republic",
    },
    {
      value: 116,
      label: 'Korea, Republic Of',
    },
    {
      value: 117,
      label: 'Kuwait',
    },
    {
      value: 118,
      label: 'Cayman Islands',
    },
    {
      value: 119,
      label: 'Kazakhstan',
    },
    {
      value: 120,
      label: "Lao People'S Dem Republic",
    },
    {
      value: 121,
      label: 'Lebanon',
    },
    {
      value: 122,
      label: 'Saint Lucia',
    },
    {
      value: 123,
      label: 'Liechtenstein',
    },
    {
      value: 124,
      label: 'Sri Lanka',
    },
    {
      value: 125,
      label: 'Liberia',
    },
    {
      value: 126,
      label: 'Lesotho',
    },
    {
      value: 127,
      label: 'Lithuania',
    },
    {
      value: 128,
      label: 'Luxembourg',
    },
    {
      value: 129,
      label: 'Latvia',
    },
    {
      value: 130,
      label: 'Libyan Arab Jamahiriya',
    },
    {
      value: 131,
      label: 'Morocco',
    },
    {
      value: 132,
      label: 'Monaco',
    },
    {
      value: 133,
      label: 'Moldova (Republica Moldova)',
    },
    {
      value: 134,
      label: 'Madagascar',
    },
    {
      value: 135,
      label: 'Marshall Islands',
    },
    {
      value: 136,
      label: 'Macedonia',
    },
    {
      value: 137,
      label: 'Mali',
    },
    {
      value: 138,
      label: 'Myanmar',
    },
    {
      value: 139,
      label: 'Mongolia',
    },
    {
      value: 140,
      label: 'Macau',
    },
    {
      value: 141,
      label: 'Northern Mariana Islands',
    },
    {
      value: 142,
      label: 'Martinique',
    },
    {
      value: 143,
      label: 'Mauritania',
    },
    {
      value: 144,
      label: 'Montserrat',
    },
    {
      value: 145,
      label: 'Malta',
    },
    {
      value: 146,
      label: 'Mauritius',
    },
    {
      value: 147,
      label: 'Maldives',
    },
    {
      value: 148,
      label: 'Malawi',
    },
    {
      value: 149,
      label: 'Mexico',
    },
    {
      value: 150,
      label: 'Malaysia',
    },
    {
      value: 151,
      label: 'Mozambique',
    },
    {
      value: 152,
      label: 'Namibia',
    },
    {
      value: 153,
      label: 'New Caledonia',
    },
    {
      value: 154,
      label: 'Niger',
    },
    {
      value: 155,
      label: 'Norfolk Island',
    },
    {
      value: 156,
      label: 'Nigeria',
    },
    {
      value: 157,
      label: 'Nicaragua',
    },
    {
      value: 158,
      label: 'Netherlands',
    },
    {
      value: 159,
      label: 'Norway',
    },
    {
      value: 160,
      label: 'Nepal',
    },
    {
      value: 161,
      label: 'Nauru',
    },
    {
      value: 162,
      label: 'Niue',
    },
    {
      value: 163,
      label: 'New Zealand',
    },
    {
      value: 164,
      label: 'Oman',
    },
    {
      value: 165,
      label: 'Panama',
    },
    {
      value: 166,
      label: 'Peru',
    },
    {
      value: 167,
      label: 'French Polynesia',
    },
    {
      value: 168,
      label: 'Papua New Guinea',
    },
    {
      value: 169,
      label: 'Philippines',
    },
    {
      value: 170,
      label: 'Pakistan',
    },
    {
      value: 171,
      label: 'Poland',
    },
    {
      value: 172,
      label: 'St. Pierre And Miquelon',
    },
    {
      value: 174,
      label: 'Puerto Rico',
    },
    {
      value: 175,
      label: 'Portugal',
    },
    {
      value: 176,
      label: 'Palau',
    },
    {
      value: 177,
      label: 'Paraguay',
    },
    {
      value: 178,
      label: 'Qatar',
    },
    {
      value: 179,
      label: 'Reunion',
    },
    {
      value: 180,
      label: 'Romania',
    },
    {
      value: 181,
      label: 'Russian Federation',
    },
    {
      value: 182,
      label: 'Rwanda',
    },
    {
      value: 183,
      label: 'Saudi Arabia',
    },
    {
      value: 184,
      label: 'Solomon Islands',
    },
    {
      value: 185,
      label: 'Seychelles',
    },
    {
      value: 186,
      label: 'Sudan',
    },
    {
      value: 187,
      label: 'Sweden',
    },
    {
      value: 188,
      label: 'Singapore',
    },
    {
      value: 189,
      label: 'St. Helena',
    },
    {
      value: 190,
      label: 'Slovenia',
    },
    {
      value: 191,
      label: 'Svalbard, Jan Mayen Islands',
    },
    {
      value: 192,
      label: 'Slovakia (Slovak Republic)',
    },
    {
      value: 193,
      label: 'Sierra Leone',
    },
    {
      value: 194,
      label: 'San Marino',
    },
    {
      value: 195,
      label: 'Senegal',
    },
    {
      value: 196,
      label: 'Somalia',
    },
    {
      value: 197,
      label: 'Suriname',
    },
    {
      value: 198,
      label: 'Sao Tome And Principe',
    },
    {
      value: 199,
      label: 'El Salvador',
    },
    {
      value: 200,
      label: 'Syrian Arab Republic',
    },
    {
      value: 201,
      label: 'Sw Aziland',
    },
    {
      value: 202,
      label: 'Turks And Caicos Islands',
    },
    {
      value: 203,
      label: 'Chad',
    },
    {
      value: 205,
      label: 'Togo',
    },
    {
      value: 206,
      label: 'Thailand',
    },
    {
      value: 207,
      label: 'Tajikistan',
    },
    {
      value: 208,
      label: 'Tokelau',
    },
    {
      value: 209,
      label: 'Turkmenistan',
    },
    {
      value: 210,
      label: 'Tunisia',
    },
    {
      value: 211,
      label: 'Tonga',
    },
    {
      value: 212,
      label: 'East Timor',
    },
    {
      value: 213,
      label: 'Turkey',
    },
    {
      value: 214,
      label: 'Trinidad And Tobago',
    },
    {
      value: 215,
      label: 'Tuvalu',
    },
    {
      value: 216,
      label: 'Taiwan',
    },
    {
      value: 217,
      label: 'Tanzania, United Republic Of',
    },
    {
      value: 218,
      label: 'Ukraine',
    },
    {
      value: 219,
      label: 'Uganda',
    },
    {
      value: 221,
      label: 'United States',
    },
    {
      value: 222,
      label: 'Uruguay',
    },
    {
      value: 223,
      label: 'Uzbekistan',
    },
    {
      value: 224,
      label: 'Vatican City (Città del Vaticano)',
    },
    {
      value: 225,
      label: 'Saint Vincent, The Grenadines',
    },
    {
      value: 226,
      label: 'Venezuela',
    },
    {
      value: 227,
      label: 'Virgin Islands (British)',
    },
    {
      value: 228,
      label: 'Virgin Islands (U.S.)',
    },
    {
      value: 229,
      label: 'Viet Nam',
    },
    {
      value: 230,
      label: 'Vanuatu',
    },
    {
      value: 231,
      label: 'Wallis And Futuna Islands',
    },
    {
      value: 232,
      label: 'Samoa',
    },
    {
      value: 233,
      label: 'Yemen',
    },
    {
      value: 234,
      label: 'Mayotte',
    },
    {
      value: 236,
      label: 'South Africa',
    },
    {
      value: 237,
      label: 'Zambia',
    },
    {
      value: 239,
      label: 'Zimbabwe',
    },
    {
      value: 240,
      label: 'Serbia',
    },
    {
      value: 242,
      label: 'Saint Martin',
    },
    {
      value: 243,
      label: 'Congo (Republic) (Congo-Brazzaville)',
    },
    {
      value: 244,
      label: 'Saint Barthélemy',
    },
    {
      value: 245,
      label: 'Guernsey',
    },
    {
      value: 246,
      label: 'Isle of Man',
    },
    {
      value: 247,
      label: 'Jersey',
    },
    {
      value: 248,
      label: 'Kosovo',
    },
    {
      value: 249,
      label: 'Curaçao',
    },
    {
      value: 250,
      label: 'Montenegro (Crna Gora)',
    },
    {
      value: 251,
      label: 'Palestine',
    },
    {
      value: 252,
      label: 'Sint Maarten',
    },
    {
      value: 253,
      label: 'South Sudan',
    },
    {
      value: 254,
      label: 'Åland Islands',
    },
  ],
  Nationality: [
    {
      value: 1,
      label: 'Afghan',
    },
    {
      value: 2,
      label: 'Albanian',
    },
    {
      value: 3,
      label: 'Algerian',
    },
    {
      value: 4,
      label: 'American',
    },
    {
      value: 5,
      label: 'Andorran',
    },
    {
      value: 6,
      label: 'Angolan',
    },
    {
      value: 7,
      label: 'Anguillan',
    },
    {
      value: 8,
      label: 'Citizen of Antigua and Barbuda',
    },
    {
      value: 9,
      label: 'Argentine',
    },
    {
      value: 10,
      label: 'Armenian',
    },
    {
      value: 11,
      label: 'Australian',
    },
    {
      value: 12,
      label: 'Austrian',
    },
    {
      value: 13,
      label: 'Azerbaijani',
    },
    {
      value: 14,
      label: 'Bahamian',
    },
    {
      value: 15,
      label: 'Bahraini',
    },
    {
      value: 16,
      label: 'Bangladeshi',
    },
    {
      value: 17,
      label: 'Barbadian',
    },
    {
      value: 18,
      label: 'Belarusian',
    },
    {
      value: 19,
      label: 'Belgian',
    },
    {
      value: 20,
      label: 'Belizean',
    },
    {
      value: 21,
      label: 'Beninese',
    },
    {
      value: 22,
      label: 'Bermudian',
    },
    {
      value: 23,
      label: 'Bhutanese',
    },
    {
      value: 24,
      label: 'Bolivian',
    },
    {
      value: 25,
      label: 'Citizen of Bosnia and Herzegovina',
    },
    {
      value: 26,
      label: 'Botswanan',
    },
    {
      value: 27,
      label: 'Brazilian',
    },
    {
      value: 28,
      label: 'British',
    },
    {
      value: 29,
      label: 'British Virgin Islander',
    },
    {
      value: 30,
      label: 'Bruneian',
    },
    {
      value: 31,
      label: 'Bulgarian',
    },
    {
      value: 32,
      label: 'Burkinan',
    },
    {
      value: 33,
      label: 'Burmese',
    },
    {
      value: 34,
      label: 'Burundian',
    },
    {
      value: 35,
      label: 'Cambodian',
    },
    {
      value: 36,
      label: 'Cameroonian',
    },
    {
      value: 37,
      label: 'Canadian',
    },
    {
      value: 38,
      label: 'Cape Verdean',
    },
    {
      value: 39,
      label: 'Cayman Islander',
    },
    {
      value: 40,
      label: 'Central African',
    },
    {
      value: 41,
      label: 'Chadian',
    },
    {
      value: 42,
      label: 'Chilean',
    },
    {
      value: 43,
      label: 'Chinese',
    },
    {
      value: 44,
      label: 'Colombian',
    },
    {
      value: 45,
      label: 'Comoran',
    },
    {
      value: 46,
      label: 'Congolese',
    },
    {
      value: 47,
      label: 'Cook Islander',
    },
    {
      value: 48,
      label: 'Costa Rican',
    },
    {
      value: 49,
      label: 'Croatian',
    },
    {
      value: 50,
      label: 'Cuban',
    },
    {
      value: 51,
      label: 'Cymraes',
    },
    {
      value: 52,
      label: 'Cymro',
    },
    {
      value: 53,
      label: 'Cypriot',
    },
    {
      value: 54,
      label: 'Czech',
    },
    {
      value: 55,
      label: 'Danish',
    },
    {
      value: 56,
      label: 'Djiboutian',
    },
    {
      value: 57,
      label: 'Dominican',
    },
    {
      value: 58,
      label: 'Citizen of the Dominican Republic',
    },
    {
      value: 59,
      label: 'Dutch',
    },
    {
      value: 60,
      label: 'East Timorese',
    },
    {
      value: 61,
      label: 'Ecuadorean',
    },
    {
      value: 62,
      label: 'Egyptian',
    },
    {
      value: 63,
      label: 'Emirati',
    },
    {
      value: 64,
      label: 'English',
    },
    {
      value: 65,
      label: 'Equatorial Guinean',
    },
    {
      value: 66,
      label: 'Eritrean',
    },
    {
      value: 67,
      label: 'Estonian',
    },
    {
      value: 68,
      label: 'Ethiopian',
    },
    {
      value: 69,
      label: 'Faroese',
    },
    {
      value: 70,
      label: 'Fijian',
    },
    {
      value: 71,
      label: 'Filipino',
    },
    {
      value: 72,
      label: 'French',
    },
    {
      value: 73,
      label: 'Gabonese',
    },
    {
      value: 74,
      label: 'Gambian',
    },
    {
      value: 75,
      label: 'Georgian',
    },
    {
      value: 76,
      label: 'German',
    },
    {
      value: 77,
      label: 'Ghanaian',
    },
    {
      value: 78,
      label: 'Gibraltarian',
    },
    {
      value: 79,
      label: 'Greek',
    },
    {
      value: 80,
      label: 'Greenlandic',
    },
    {
      value: 81,
      label: 'Grenadian',
    },
    {
      value: 82,
      label: 'Guamanian',
    },
    {
      value: 83,
      label: 'Guatemalan',
    },
    {
      value: 84,
      label: 'Citizen of Guinea-Bissau',
    },
    {
      value: 85,
      label: 'Guinean',
    },
    {
      value: 86,
      label: 'Guyanese',
    },
    {
      value: 87,
      label: 'Haitian',
    },
    {
      value: 88,
      label: 'Honduran',
    },
    {
      value: 89,
      label: 'Hong Konger',
    },
    {
      value: 90,
      label: 'Hungarian',
    },
    {
      value: 91,
      label: 'Icelandic',
    },
    {
      value: 92,
      label: 'Indian',
    },
    {
      value: 93,
      label: 'Indonesian',
    },
    {
      value: 94,
      label: 'Iranian',
    },
    {
      value: 95,
      label: 'Iraqi',
    },
    {
      value: 96,
      label: 'Irish',
    },
    {
      value: 97,
      label: 'Israeli',
    },
    {
      value: 98,
      label: 'Italian',
    },
    {
      value: 99,
      label: 'Ivorian',
    },
    {
      value: 100,
      label: 'Jamaican',
    },
    {
      value: 101,
      label: 'Japanese',
    },
    {
      value: 102,
      label: 'Jordanian',
    },
    {
      value: 103,
      label: 'Kazakh',
    },
    {
      value: 104,
      label: 'Kenyan',
    },
    {
      value: 105,
      label: 'Kittitian',
    },
    {
      value: 106,
      label: 'Citizen of Kiribati',
    },
    {
      value: 107,
      label: 'Kosovan',
    },
    {
      value: 108,
      label: 'Kuwaiti',
    },
    {
      value: 109,
      label: 'Kyrgyz',
    },
    {
      value: 110,
      label: 'Lao',
    },
    {
      value: 111,
      label: 'Latvian',
    },
    {
      value: 112,
      label: 'Lebanese',
    },
    {
      value: 113,
      label: 'Liberian',
    },
    {
      value: 114,
      label: 'Libyan',
    },
    {
      value: 115,
      label: 'Liechtenstein citizen',
    },
    {
      value: 116,
      label: 'Lithuanian',
    },
    {
      value: 117,
      label: 'Luxembourger',
    },
    {
      value: 118,
      label: 'Macanese',
    },
    {
      value: 119,
      label: 'Macedonian (FYRO)',
    },
    {
      value: 120,
      label: 'Malagasy',
    },
    {
      value: 121,
      label: 'Malawian',
    },
    {
      value: 122,
      label: 'Malaysian',
    },
    {
      value: 123,
      label: 'Maldivian',
    },
    {
      value: 124,
      label: 'Malian',
    },
    {
      value: 125,
      label: 'Maltese',
    },
    {
      value: 126,
      label: 'Marshallese',
    },
    {
      value: 127,
      label: 'Martiniquais',
    },
    {
      value: 128,
      label: 'Mauritanian',
    },
    {
      value: 129,
      label: 'Mauritian',
    },
    {
      value: 130,
      label: 'Mexican',
    },
    {
      value: 131,
      label: 'Micronesian',
    },
    {
      value: 132,
      label: 'Moldovan',
    },
    {
      value: 133,
      label: 'Monegasque',
    },
    {
      value: 134,
      label: 'Mongolian',
    },
    {
      value: 135,
      label: 'Montenegrin',
    },
    {
      value: 136,
      label: 'Montserratian',
    },
    {
      value: 137,
      label: 'Moroccan',
    },
    {
      value: 138,
      label: 'Mosotho',
    },
    {
      value: 139,
      label: 'Mozambican',
    },
    {
      value: 140,
      label: 'Namibian',
    },
    {
      value: 141,
      label: 'Nauruan',
    },
    {
      value: 142,
      label: 'Nepalese',
    },
    {
      value: 143,
      label: 'New Zealander',
    },
    {
      value: 144,
      label: 'Nicaraguan',
    },
    {
      value: 145,
      label: 'Nigerian',
    },
    {
      value: 146,
      label: 'Nigerien',
    },
    {
      value: 147,
      label: 'Niuean',
    },
    {
      value: 148,
      label: 'North Korean',
    },
    {
      value: 149,
      label: 'Northern Irish',
    },
    {
      value: 150,
      label: 'Norwegian',
    },
    {
      value: 151,
      label: 'Omani',
    },
    {
      value: 152,
      label: 'Pakistani',
    },
    {
      value: 153,
      label: 'Palauan',
    },
    {
      value: 154,
      label: 'Palestinian',
    },
    {
      value: 155,
      label: 'Panamanian',
    },
    {
      value: 156,
      label: 'Papua New Guinean',
    },
    {
      value: 157,
      label: 'Paraguayan',
    },
    {
      value: 158,
      label: 'Peruvian',
    },
    {
      value: 159,
      label: 'Pitcairn Islander',
    },
    {
      value: 160,
      label: 'Polish',
    },
    {
      value: 161,
      label: 'Portuguese',
    },
    {
      value: 162,
      label: 'Prydeinig',
    },
    {
      value: 163,
      label: 'Puerto Rican',
    },
    {
      value: 164,
      label: 'Qatari',
    },
    {
      value: 165,
      label: 'Romanian',
    },
    {
      value: 166,
      label: 'Russian',
    },
    {
      value: 167,
      label: 'Rwandan',
    },
    {
      value: 168,
      label: 'Salvadorean',
    },
    {
      value: 169,
      label: 'Sammarinese',
    },
    {
      value: 170,
      label: 'Samoan',
    },
    {
      value: 171,
      label: 'Sao Tomean',
    },
    {
      value: 172,
      label: 'Saudi Arabian',
    },
    {
      value: 173,
      label: 'Scottish',
    },
    {
      value: 174,
      label: 'Senegalese',
    },
    {
      value: 175,
      label: 'Serbian',
    },
    {
      value: 176,
      label: 'Citizen of Seychelles',
    },
    {
      value: 177,
      label: 'Sierra Leonean',
    },
    {
      value: 178,
      label: 'Singaporean',
    },
    {
      value: 179,
      label: 'Slovak',
    },
    {
      value: 180,
      label: 'Slovenian',
    },
    {
      value: 181,
      label: 'Solomon Islander',
    },
    {
      value: 182,
      label: 'Somali',
    },
    {
      value: 183,
      label: 'South African',
    },
    {
      value: 184,
      label: 'South Korean',
    },
    {
      value: 185,
      label: 'South Sudanese',
    },
    {
      value: 186,
      label: 'Spanish',
    },
    {
      value: 187,
      label: 'Sri Lankan',
    },
    {
      value: 188,
      label: 'St Helenian',
    },
    {
      value: 189,
      label: 'St Lucian',
    },
    {
      value: 190,
      label: 'Stateless',
    },
    {
      value: 191,
      label: 'Sudanese',
    },
    {
      value: 192,
      label: 'Surinamese',
    },
    {
      value: 193,
      label: 'Swazi',
    },
    {
      value: 194,
      label: 'Swedish',
    },
    {
      value: 195,
      label: 'Swiss',
    },
    {
      value: 196,
      label: 'Syrian',
    },
    {
      value: 197,
      label: 'Taiwanese',
    },
    {
      value: 198,
      label: 'Tajik',
    },
    {
      value: 199,
      label: 'Tanzanian',
    },
    {
      value: 200,
      label: 'Thai',
    },
    {
      value: 201,
      label: 'Togolese',
    },
    {
      value: 202,
      label: 'Tongan',
    },
    {
      value: 203,
      label: 'Trinidadian',
    },
    {
      value: 204,
      label: 'Tristanian',
    },
    {
      value: 205,
      label: 'Tunisian',
    },
    {
      value: 206,
      label: 'Turkish',
    },
    {
      value: 207,
      label: 'Turkmen',
    },
    {
      value: 208,
      label: 'Turks and Caicos Islander',
    },
    {
      value: 209,
      label: 'Tuvaluan',
    },
    {
      value: 210,
      label: 'Ugandan',
    },
    {
      value: 211,
      label: 'Ukrainian',
    },
    {
      value: 212,
      label: 'Uruguayan',
    },
    {
      value: 213,
      label: 'Uzbek',
    },
    {
      value: 214,
      label: 'Vatican citizen',
    },
    {
      value: 215,
      label: 'Citizen of Vanuatu',
    },
    {
      value: 216,
      label: 'Venezuelan',
    },
    {
      value: 217,
      label: 'Vietnamese',
    },
    {
      value: 218,
      label: 'Vincentian',
    },
    {
      value: 219,
      label: 'Wallisian',
    },
    {
      value: 220,
      label: 'Welsh',
    },
    {
      value: 221,
      label: 'Yemeni',
    },
    {
      value: 222,
      label: 'Zambian',
    },
    {
      value: 223,
      label: 'Zimbabwean',
    },
    {
      value: 224,
      label: 'Antarctician',
    },
    {
      value: 225,
      label: 'Aruban',
    },
    {
      value: 226,
      label: 'Finnish',
    },
    {
      value: 227,
      label: 'British Islands',
    },
    {
      value: 228,
      label: 'British Overseas Territories',
    },
    {
      value: 229,
      label: 'Not Specified',
    },
    {
      value: 230,
      label: 'American Islander',
    },
    {
      value: 231,
      label: 'Zairian',
    },
  ],
  SelfEmployedTradingType: [
    {
      value: 1,
      label: 'Sole Trader/Partner',
    },
    {
      value: 2,
      label: 'Limited Company',
    },
  ],
  IndustryType: [
    {
      value: 1,
      label: 'Retail & wholesale',
    },
    {
      value: 2,
      label: 'Health & social care',
    },
    {
      value: 3,
      label: 'Professional & technical',
    },
    {
      value: 4,
      label: 'Admin and support',
    },
    {
      value: 5,
      label: 'Education',
    },
    {
      value: 6,
      label: 'Manufacturing',
    },
    {
      value: 7,
      label: 'Accommodation & food',
    },
    {
      value: 8,
      label: 'Construction',
    },
    {
      value: 9,
      label: 'Transport',
    },
    {
      value: 10,
      label: 'Public sector & defence',
    },
    {
      value: 11,
      label: 'IT & communications',
    },
    {
      value: 12,
      label: 'Financial services',
    },
    {
      value: 13,
      label: 'Arts, entertainment & recreation',
    },
    {
      value: 14,
      label: 'Other services',
    },
    {
      value: 15,
      label: 'Real estate activities',
    },
    {
      value: 16,
      label: 'Utilities',
    },
    {
      value: 17,
      label: 'Agriculture',
    },
  ],
  PaidTermType: [
    {
      value: 1,
      label: 'Daily',
    },
    {
      value: 2,
      label: 'Weekly',
    },
    {
      value: 3,
      label: 'Two Weekly',
    },
    {
      value: 4,
      label: 'Four Weekly',
    },
    {
      value: 5,
      label: 'Monthly',
    },
    {
      value: 6,
      label: 'Quarterly',
    },
    {
      value: 7,
      label: 'Annually',
    },
  ],
  BonusReceived: [
    {
      value: 1,
      label: 'Monthly',
    },
    {
      value: 2,
      label: 'Weekly',
    },
    {
      value: 3,
      label: 'Quarterly',
    },
    {
      value: 4,
      label: 'Yearly',
    },
  ],
  TypeOfEmployment: [
    {
      value: 1,
      label: 'Permanent-Full Time',
    },
    {
      value: 2,
      label: 'Permanent-Part Time',
    },
    {
      value: 3,
      label: 'Temporary-Full Time',
    },
    {
      value: 4,
      label: 'Temporary-Part Time',
    },
  ],
};
